import React from 'react'
import { Checkbox, FormControlLabel } from '@mui/material'
import { Controller } from 'react-hook-form'
import PatientFormField from '../PatientFormField'
import { PatientIdentityAttributesProps } from './_props'
import { IdentityAttributes, shouldDirty } from './_utils/_utils'
import { useFormContextPatient } from '../_utils'
import useAutomaticIdentityValidation from '../../../../hooks/useAutomaticIdentityValidation'

const PatientIdentityAttributes = ({ onChange, onManualIdentityValidation }: PatientIdentityAttributesProps) => {
    const { control, setValue, watch } = useFormContextPatient()
    const { isAutomaticIdentityValidationDisabled } = useAutomaticIdentityValidation()

    const watched = {
        insiIdentityAttributes: watch('insiIdentityAttributes') ?? undefined,
        manualIdentityValidation: watch('manualIdentityValidation') ?? false,
        identityProof: watch('identityProof') ?? undefined,
    }

    const isFictitiousOrDoubtful = watched.insiIdentityAttributes.some((code) => [2, 3].includes(code))

    React.useEffect(() => {
        if (isFictitiousOrDoubtful) {
            setValue('manualIdentityValidation', false)
        }
        if (watched.identityProof?.level !== 2) {
            setValue('manualIdentityValidation', false)
        }
    }, [isFictitiousOrDoubtful, setValue, watched.identityProof?.level])

    return (
        <Controller
            control={control}
            name="insiIdentityAttributes"
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="custom"
                    label="Nature de l'identité"
                    name={field.name}
                    size="1"
                    status={{
                        error,
                        valid: (field.value?.length ?? 0) > 0 || watched.manualIdentityValidation,
                    }}
                    render={() => (
                        <>
                            {isAutomaticIdentityValidationDisabled && (
                                <Controller
                                    control={control}
                                    name="manualIdentityValidation"
                                    render={(fieldProps) => (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={fieldProps.field.value ?? false}
                                                    color="primary"
                                                    onChange={(e) => {
                                                        fieldProps.field.onChange(e)
                                                        onManualIdentityValidation(e.currentTarget.checked)
                                                    }}
                                                    value="manualIdentityValidation"
                                                />
                                            }
                                            label="Identité validée"
                                            disabled={isFictitiousOrDoubtful || watched.identityProof?.level !== 2}
                                        />
                                    )}
                                />
                            )}

                            {IdentityAttributes?.map((attribute) => {
                                const isSelected = () => (field.value ?? []).some((val) => val === attribute.code)
                                return (
                                    <FormControlLabel
                                        key={`identityAyttribute${attribute.code}`}
                                        control={
                                            <Checkbox
                                                checked={isSelected()}
                                                color="primary"
                                                onChange={() => {
                                                    const valueIndex = field.value?.findIndex(
                                                        (code) => code === attribute.code,
                                                    )
                                                    if (valueIndex !== -1) field.value?.splice(valueIndex, 1)
                                                    else field.value?.push(attribute.code)
                                                    setValue('insiIdentityAttributes', field.value, shouldDirty)
                                                    onChange()
                                                }}
                                                value={attribute.code}
                                            />
                                        }
                                        label={attribute.label}
                                    />
                                )
                            })}
                        </>
                    )}
                />
            )}
        />
    )
}

export default PatientIdentityAttributes
